import { Cliente, getClienteDefault } from "src/app/interface/cliente";

export interface ProcessoCadastroRevisaoCliente {
    cliente: Cliente;
    CSTATUS_PROCESSO: string;
    CCODIGOLOJA: string;
    COBSERVACAO: string;
    NPROCESSO: number;

}

export const getProcessoCadastroRevisaoClienteDefault = (): ProcessoCadastroRevisaoCliente => {
  return {
    cliente: getClienteDefault(),
    CSTATUS_PROCESSO: '',
    CCODIGOLOJA: '',
    COBSERVACAO: ' ',
    NPROCESSO: 0,
  };
};
